import config from 'config'

/**
 * NavDropdown :
 *   グローバルメニューのドロップダウン
 */

class NavDropdown {

  constructor() {
    this.body = document.querySelector('body')
    this.navList = document.querySelector('.p-nav__list')
    this.parentTrigger = document.querySelectorAll('.p-nav__trigger,.p-footerNav__trigger')
    this.parentOther = document.querySelectorAll('.p-nav__other')
    this.parentItem = document.querySelectorAll('.p-nav__item')
    this.childList = document.querySelectorAll('.p-nav__child')
    this.childLink = document.querySelectorAll('.p-nav__link2')
    this.drawer = document.querySelector('.p-drawer')
    this.drawerToggler = document.querySelector('.p-drawer-toggler')
    this.drawerDackdrop = document.querySelector('.p-drawer__backdrop')
    this.pageCrItem = false
    this.focusName = '-focus'
    this.openName = '-open'
    this.bodyOpenName = '-menuOpen'
  }

  init() {
    this.setPageCrItem()
    this.attachEvent()
  }

  setPageCrItem() {
    if (config.isSP) return

    const bodyClasses = this.body.classList.value
    if (/news|media/.test(bodyClasses)) {
      this.pageCrItem = document.querySelector('#newsTrigger')
    } else if (/company/.test(bodyClasses)) {
      this.pageCrItem = document.querySelector('#companyTrigger')
    } else if (/business/.test(bodyClasses)) {
      this.pageCrItem = document.querySelector('#businessTrigger')
    } else if (/recruit/.test(bodyClasses)) {
      this.pageCrItem = document.querySelector('#recruitTrigger')
    } else {
      this.pageCrItem = false
    }
  }

  attachEvent() {
    if (config.isPC) {
      // p-nav__itemから親への伝播を止める
      Array.from(this.parentItem, elem => {
        elem.addEventListener('mouseenter', this.stopPropagation, false)
        elem.addEventListener('mouseleave', this.stopPropagation, false)
      });

      // NEWSから左へホバーアウトしたときに pageCrItem に -focus が戻らない対策
      // this.navList.addEventListener('mouseleave', this.onOtherElem.bind(this)), false;
      Array.from(this.parentOther, elem => {
        elem.addEventListener('mouseenter', this.onOtherElem.bind(this), false)
        elem.addEventListener('mouseleave', this.blurOtherElem.bind(this), false)
      });

      // .p-nav__button にホバーした時に -focus を付与
      Array.from(this.parentTrigger, elem => {
        elem.addEventListener('mouseenter', this.focusParentTrigger.bind(this), false)
        elem.addEventListener('focus', this.focusParentTrigger.bind(this), false)
      });

      // .p-nav__button からホバーアウトした時に -focus を削除
      Array.from(this.parentTrigger, elem => {
        elem.addEventListener('mouseleave', this.blurParentTrigger.bind(this), false)
        elem.addEventListener('blur', this.blurParentTrigger.bind(this), false)
      });

      // p-nav__child にホバーしている間は trigger の -focus を維持
      Array.from(this.childList, elem => {
        elem.addEventListener('mouseenter', this.focusChildList.bind(this), false)
      });
      Array.from(this.childList, elem => {
        elem.addEventListener('mouseleave', this.blurChildList.bind(this), false)
      });

      // .p-nav__link2 にフォーカスした時に対応する .p-nav__button に -focus を付与
      Array.from(this.childLink, elem => {
        elem.addEventListener('focus', this.focusChildItem.bind(this), false)
      });
      // .p-nav__link2 からフォーカスアウトした時に対応する .p-nav__button から -focus を削除
      Array.from(this.childLink, elem => {
        elem.addEventListener('blur', this.blurChildItem.bind(this), false)
      });
    } else {
      Array.from(this.parentTrigger, elem => {
        elem.addEventListener('click', (event) => {
          event.preventDefault()
          this.clickParentTrigger(elem)
        }, false)
      });

      this.drawerToggler.addEventListener('click', () => this.clickDrawerToggler(), false)

      this.drawerDackdrop.addEventListener('click', () => this.closeMenu(), false)
    }
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  addFocus(target) {
    target.classList.add(this.focusName)
  }

  removeFocus(target) {
    target.classList.remove(this.focusName)
  }

  openMenu() {
    this.body.classList.add(this.bodyOpenName)
    this.drawer.classList.add(this.openName)
    this.drawerToggler.classList.add(this.openName)
    this.drawerToggler.setAttribute('aria-expanded', true)
  }

  closeMenu() {
    this.body.classList.remove(this.bodyOpenName)
    this.drawer.classList.remove(this.openName)
    this.drawerToggler.classList.remove(this.openName)
    this.drawerToggler.setAttribute('aria-expanded', false)
  }

  onOtherElem(event) {
    if (this.pageCrItem) {
      this.removeFocus(this.pageCrItem)
    }
  }

  blurOtherElem(event) {
    if (this.pageCrItem) {
      this.addFocus(this.pageCrItem)
    }
  }

  focusParentTrigger(event) {
    // まず全ての .p-nav__button から -focus を外す
    Array.from(this.parentTrigger, elem2 => {
      this.removeFocus(elem2)
    })
    // 対応するものに -focus をつける
    this.addFocus(event.target)
  }

  blurParentTrigger(event) {
    // -focus を削除
    this.removeFocus(event.target)
  }

  focusChildList(event) {
    this.addFocus(event.target.previousElementSibling)
  }

  blurChildList(event) {
    this.removeFocus(event.target.previousElementSibling)

    // pageCrItemに -focus を付与
    if (this.pageCrItem && event.type === 'mouseleave') {
      this.addFocus(this.pageCrItem)
    }
  }

  focusChildItem(event) {
    this.addFocus(event.target.closest('.p-nav__child').previousElementSibling)
  }

  blurChildItem(event) {
    this.removeFocus(event.target.closest('.p-nav__child').previousElementSibling)

    // pageCrItemに -focus を付与
    if (this.pageCrItem && event.type === 'mouseleave') {
      this.addFocus(this.pageCrItem)
    }
  }

  clickParentTrigger(el) {
    const targetEl = document.getElementById(el.getAttribute('data-target'))

    if (!targetEl) return

    const height = !targetEl ? 0 : targetEl.scrollHeight

    if ( el.classList.contains(this.openName) ) {
      el.classList.remove(this.openName)
      targetEl.style.maxHeight = ''
    } else {
      el.classList.add(this.openName)
      targetEl.style.maxHeight = `${height}px`
    }
  }

  clickDrawerToggler(ev) {
    event.preventDefault()

    if ( this.drawerToggler.classList.contains(this.openName) ) {
      this.closeMenu()
    } else {
      this.openMenu()
    }
  }
}

export default NavDropdown



// WEBPACK FOOTER //
// ./src/script/modules/NavDropdown.js